import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Luxurious%20editorial%20flat%20lay%20photography%20of%20curated%20fashion%20accessories%20and%20lifestyle%20products%20including%20a%20structured%20tan%20leather%20tote%20bag%20folded%20cashmere%20scarf%20in%20warm%20sand%20tones%20artisan%20ceramic%20vessels%20and%20a%20minimalist%20hardcover%20journal%20arranged%20on%20natural%20linen%20fabric%20with%20soft%20golden%20hour%20window%20light%20streaming%20diagonally%20across%20warm%20sophisticated%20palette%20with%20touches%20of%20olive%20green%20and%20terracotta%20creating%20an%20aspirational%20lifestyle%20aesthetic&width=1600&height=900&seq=cta-bg-v2-june-oopbuy&orientation=landscape`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div className="lg:pt-20">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight">
              start sourcing
              <br />
              smarter today
            </h2>
            <div className="mt-8">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-3 px-7 py-3.5 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
              >
                Explore Now
                <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-background-50 text-sm"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="lg:pb-16 lg:text-right">
            <p className="text-sm md:text-base text-background-100/80 leading-relaxed max-w-sm">
              Access structured product data,
              <br />
              compare listings efficiently, and make
              <br />
              data-driven sourcing decisions.
            </p>
            <div className="mt-4 flex flex-wrap gap-3 lg:justify-end">
              <Link
                to="/what-is-oopbuy-spreadsheet"
                className="text-xs text-background-100/70 hover:text-background-50 underline transition-colors cursor-pointer"
              >
                Read SEO Guides
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-100/70 hover:text-background-50 underline transition-colors cursor-pointer"
              >
                Visit Main Platform
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}